import {
  V1_INGREDIENT_CATEGORIES,
  V1_CREATE_ALL_OUTLET,
  V1_INGREDIENT_CATEGORY_BY_ID,
  V1_INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT
} from './constants'

function resolve (res) {
  return Promise.resolve(res)
}

function reject (error) {
  let eobj
  if (error.response) {
    let data = error.response.data
    if (data.errors) {
      eobj = new Error(data.errors)
    } else if (data.message) {
      eobj = new Error(data.message)
    } else {
      eobj = new Error(error.message)
    }
  } else {
    eobj = new Error(error.message)
  }
  return Promise.reject(eobj)
}

export function getCategories (params) {
  return axios.get(V1_INGREDIENT_CATEGORIES, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function postCategory (data, params) {
  return axios.post(V1_INGREDIENT_CATEGORIES, data, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function putCategory (id, data, params) {
  return axios.put(V1_INGREDIENT_CATEGORY_BY_ID(id), data, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function deleteCategory (id, params) {
  return axios.delete(V1_INGREDIENT_CATEGORY_BY_ID(id), {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function postCreateAllOutlet (data, params) {
  return axios.post(V1_CREATE_ALL_OUTLET, data, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function assignToIngredient (id, data, params) {
  return axios.put(V1_INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT(id), data, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}



// WEBPACK FOOTER //
// ./app/api/ingredientCategories/ingredientCategories.js